<template>
  <v-chip :color="isVoice ? 'primary' : 'indigo'" size="small" variant="tonal" label :prepend-icon="isVoice ? 'mdi-phone' : 'mdi-message-text'">
    {{ isVoice ? $t('qaVoice') : $t('qaChat') }}
  </v-chip>
</template>

<script>
/**
 * ป้าย "ประเภทงาน" ของเคส — สายสนทนา หรือ แชท
 *
 * ⚠️ ห้ามเอาช่องทางโซเชียล (LINE / Facebook / Instagram) มาแสดงในนี้
 *    ทุกเคสที่ระบบเก็บได้ตอนนี้เป็นแชททั้งหมด ถ้าเอามารวมกัน ช่อง "ประเภท"
 *    จะกลายเป็นช่องบอกชื่อ OA แทน และไม่เหลืออะไรบอกว่าเป็นสายหรือแชท
 *    ช่องทางโซเชียลมีคอลัมน์ของตัวเองแล้ว — ดู QaSocialChip.vue
 */
export default {
  name: 'QaChannelChip',
  props: {
    channel: { type: String, required: true },
  },
  computed: {
    isVoice() {
      return this.channel === 'voice';
    },
  },
};
</script>
